/* global DetectUserAgent */
import { isNil } from "ramda";

import { appRoutes } from "routes";

const DEFAULT_PERMISSION_USER_PHOTOS = "user_photos";

const encodeParams = (params) =>
  `?${Object.keys(params)
    .map((param) => `${param}=${encodeURIComponent(params[param])}`)
    .join("&")}`;

const getParamsApi = (token) => {
  const isFB4Android = DetectUserAgent.isFB4Android();
  return isFB4Android ? `access_token=${token}` : "";
};

export const init = (fbAppId, onChangeInitialized) => {
  return new Promise((resolve, reject) => {
    if (typeof window?.FB !== "undefined") {
      onChangeInitialized(true);
      resolve();
    } else {
      window.fbAsyncInit = () => {
        window.FB.init({
          appId: fbAppId,
          autoLogAppEvents: true,
          xfbml: true,
          version: "v13.0",
        });
        onChangeInitialized(true);
        resolve();
      };
      ((d, s, id) => {
        const fjs = document.body;
        if (d.getElementById(id)) {
          reject();
          return;
        }
        const js = d.createElement(s);
        js.setAttribute("id", id);
        js.setAttribute("crossorigin", "anonymous");
        js.setAttribute("async", true);
        js.setAttribute("defer", true);
        js.setAttribute("src", "https://connect.facebook.net/en_US/sdk.js");
        fjs.appendChild(js);
      })(document, "script", "facebook-jssdk");
    }
  });
};

export const validatePermissions = (currentStatus, accessToken) => {
  return new Promise((resolve, reject) => {
    if (currentStatus === "connected" || accessToken) {
      window.FB.api(`/me/permissions?${getParamsApi(accessToken)}`, (response) => {
        if (response && response?.error) {
          reject();
        }
        const permissions = response?.data;
        const userPhotosPermissions = permissions?.find(
          ({ permission }) => permission === DEFAULT_PERMISSION_USER_PHOTOS,
        );
        if (userPhotosPermissions?.status === "granted") {
          resolve("connected");
        }
      });
    } else {
      reject();
    }
  });
};

export const getNextPage = (nextPage, setNextPage) => {
  return new Promise((resolve, reject) => {
    window.FB.api(nextPage, (response) => {
      if (response && response?.error) {
        reject();
      } else {
        resolve(response.data);
        setNextPage(response?.paging?.next);
      }
    });
  });
};

export const checkLoggedin = () => {
  return new Promise((resolve, reject) => {
    window.FB.getLoginStatus((response) => {
      if (response && response?.error) {
        reject();
      } else {
        resolve(response.status);
      }
    });
  });
};

export const getImagesOfAlbum = (albumId, setNext, accessToken) => {
  return new Promise((resolve, reject) => {
    window.FB.api(
      `/${albumId}/photos?${getParamsApi(accessToken)}`,
      (response) => {
        if (response && response?.error) {
          reject();
        } else {
          resolve(response.data);
          setNext(response?.paging?.next);
        }
      },
      {
        fields: "images,created_time,name",
      },
    );
  });
};

export const getAllAlbums = (setNext, accessToken) => {
  return new Promise((resolve, reject) => {
    window.FB.api(
      `/me/albums?${getParamsApi(accessToken)}`,
      (response) => {
        if (response && response?.error) {
          reject();
        } else {
          resolve(response?.data);
          setNext(response?.paging?.next);
        }
      },
      {
        fields: "id,name,cover_photo{id,images}",
      },
    );
  });
};

export const login = () => {
  return new Promise((resolve, reject) => {
    window.FB.login(
      (response) => {
        if ((response && response?.error) || isNil(response?.authResponse)) {
          reject();
        } else {
          resolve(response.status);
        }
      },
      {
        scope: "user_photos",
      },
    );
  });
};

export const customLogin = (fbAppId) => {
  const redirectPath = `https://${window.location.host + appRoutes.oAuthRedirectPath()}`;
  const params = {
    client_id: fbAppId,
    redirect_uri: redirectPath,
    state: `{ "from": "${window.location.href}" }`,
    scope: "user_photos",
    response_type: "token",
  };
  window.location.replace(`https://www.facebook.com/dialog/oauth${encodeParams(params)}`);
};
